import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import {
  pageAtom,
  myNftAtom,
  myNftBackAtom,
  isAuthAtom,
  displayNameAtom,
  topMessageAtom,
} from '../../State';
import { useRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeWhiteButton.svg';
import MetaMaskButton from '../Images/buttons/connectMetaMaskButton.png';
import './ElectronMetaMask.css';
import DataModel from '../Util/DataModel';
import Loading from '../Loading/Loading';

export default function ElectronMetaMask() {
  const callObject = useDaily();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const [myNftBackState, setMyNftBackState] = useRecoilState(myNftBackAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);
  const [topMessageState, setTopMessageState] = useRecoilState(topMessageAtom);

  //その他
  const codeValue = useRef('');
  const [loadingState, setLoadingState] = useState(false);

  //urlの入力エリア
  const onCodeChange = (e) => {
    codeValue.current = e.target.value;
  };

  //オープンブラウザ
  const openBrowser = async () => {
    const buff = await window.myapi.openLink('https://faceless.ooo/login');
  };

  //認証
  const verify = async () => {
    //ローディング開始
    setLoadingState(true);

    //コードからトークンとユーザー情報を取得
    const userData = await DataModel.getTokenFromCode(codeValue.current);
    var error = false;

    if (userData != null && userData.token != null) {
      //Firebaseにログイン
      const isLogin = await DataModel.signInFirebase(userData);

      if (isLogin != null) {
        //各種値をセット
        setAuthState(true);
        setDisplayNameState(userData.displayName);
        setMyNftState(userData.imageURL);
        setMyNftBackState(userData.imageBackURL);

        //コールオブジェクト
        if (callObject != null) {
          callObject.setUserName(userData.displayName);
        }

        //メインページへ戻る
        setPageState('main');
      } else {
        error = true;
      }
    } else {
      error = true;
    }

    //ローディング終了
    setLoadingState(false);

    //ログイン成功
    setTopMessageState({
      type: 'joined',
      message: 'Login Successfully',
    });

    //エラーがある場合
    if (error) {
      setTopMessageState({
        type: 'joined',
        message: 'There is an error',
      });
      console.log('ログインエラーです');
    }
  };

  //背景をタップ時
  const tapBack = () => {
    setPageState('main');
  };

  //レンダービュー
  const renderScreen = () => {
    return (
      <>
        {/*　ローディング */}
        <Loading loadingState={loadingState} />
        <div id="backWrap" onClick={tapBack}></div>
        <div id="electronTopWrap">
          <div id="nftTitle">
            Login with MetaMask
            <div id="nftCloseButton">{/* <CloseSVG onClick={tapBack} /> */}</div>
          </div>

          <div id="electronMetaWrap">
            <div style={{ textAlign: 'center' }}>
              <img src="./images/header/metaMask.svg" />
            </div>
            <div className="electronH1">
              <span className="electronNumber">1.</span> Open the link below using Browser & connect
              to MetaMask
            </div>
            <div className="electronAreaWrap">
              <div id="electronURL">https://faceless.ooo/login </div>
              <div id="electronOpen">
                <button onClick={openBrowser}>Open browser </button>
              </div>
            </div>
            <div className="electronH1">
              <span className="electronNumber">2.</span> Paste the verificartion code below
            </div>

            <div className="electronAreaWrap">
              <input
                type="text"
                placeholder="paste verification code"
                onChange={(e) => onCodeChange(e)}
              />

              <div id="electroyVerify">
                <button onClick={verify}>Verify</button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return renderScreen();
}
